import request from '@/utils/request'

// 查询顶部列表
export function listTop(query) {
  return request({
    url: '/ws/top/list',
    method: 'get',
    params: query
  })
}



